import { useTheme } from '../../../hooks/use-theme';
import { SunIcon } from '../../icons/sun-icon';
import { MoonIcon } from '../../icons/moon-icon';

export const ThemeToggle = () => {
  const { isDarkMode, toggleTheme } = useTheme();

  const onClick = () => {
    toggleTheme();
  };

  return (
    <a class="theme-toggle" onClick={onClick}>
      {isDarkMode ? (
        <span class="night-mode">
          <MoonIcon />
        </span>
      ) : (
        <span class="day-mode">
          <SunIcon />
        </span>
      )}
    </a>
  );
};
